// extracted by mini-css-extract-plugin
module.exports = {"counter":"QtySelect_counter__14lN0","sm":"QtySelect_sm__22FhX"};